var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"offcanvas",class:{
      'is-active': _vm.config.isActive,
      'is-large': _vm.config.isLarge,
      'is-widget': _vm.config.isWidget,
    }},[_c('div',{staticClass:"offcanvas-backdrop",on:{"click":function($event){return _vm.close()}}}),_c('div',{staticClass:"offcanvas-content"},[_c('header',{staticClass:"offcanvas-head"},[_vm._t("header")],2),_c('section',{staticClass:"offcanvas-body"},[_vm._t("default")],2),_c('footer',{staticClass:"offcanvas-foot"},[_vm._t("footer")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }